import { render } from "./FpuiInputCheckbox.vue?vue&type=template&id=4bbd6b05"
import script from "./FpuiInputCheckbox.vue?vue&type=script&lang=js"
export * from "./FpuiInputCheckbox.vue?vue&type=script&lang=js"

import "./FpuiInputCheckbox.vue?vue&type=style&index=0&id=4bbd6b05&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__